import type { Locale } from '$lib/i18n/types';

export interface LocaleSurvey {
	description: string;
	cta: string;
	closeAriaLabel: string;
	href: string;
	enabled: boolean;
}

const content = {
	'fr-FR': {
		description:
			'Répondez en quelques minutes à notre questionnaire pour nous permettre de mieux connaître vos attentes ! ',
		cta: 'Je réponds',
		closeAriaLabel: 'Fermer',
		href: 'https://chat.episto.fr/?s=ELN7Ew08__I&lg=fr-kSSu&cc=FR&z=2',
		enabled: false,
	},
	'it-IT': {
		description:
			'Rispondete in pochi minuti al nostro questionario per permetterci di conoscere meglio le vostre aspettative ! ',
		cta: 'Rispondo',
		closeAriaLabel: 'Chiudi',
		href: 'https://chat.episto.fr/?s=ELN7Ew08__I&lg=it-FbDX&cc=IT&z=2',
		enabled: true,
	},
} as const satisfies Record<string, LocaleSurvey>;

export type SupportedLocales = keyof typeof content;

export interface BVASurvey {
	active: boolean;
	delay: number;
	maxNbOpenPerSession: number;
	sessionKey: string;
	content: Record<SupportedLocales, LocaleSurvey>;
	isSupportedLocale: (locale: Locale) => locale is SupportedLocales;
	getSurvey: (locale: SupportedLocales) => LocaleSurvey | undefined;
};

export const bvaSurvey = {
	active: true,
	delay: 5000,
	maxNbOpenPerSession: 1,
	sessionKey: 'surveyNbOpen',
	content,
	isSupportedLocale: (locale: Locale): locale is SupportedLocales => {
		return locale in content;
	},
	getSurvey: (locale: SupportedLocales) => {
		return content[locale].enabled ? content[locale] : undefined;
	},
} as const satisfies BVASurvey;
